import { Button, Dialog, Text } from "@ui5/webcomponents-react";
import { useTranslation } from "react-i18next";

export interface DiscardChangesDialogProps {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
}

/** Asks before unsaved changes are thrown away (cancel, navigation away). */
export function DiscardChangesDialog({ open, onDiscard, onKeepEditing }: DiscardChangesDialogProps) {
  const { t } = useTranslation("ui");
  return (
    <Dialog
      open={open}
      headerText={t("discard.title")}
      state="Critical"
      data-testid="discard-dialog"
      onClose={onKeepEditing}
      footer={
        <div className="positive-dialog-footer">
          <Button design="Emphasized" onClick={onDiscard} data-testid="discard-confirm">
            {t("discard.discard")}
          </Button>
          <Button design="Transparent" onClick={onKeepEditing} data-testid="discard-keep">
            {t("discard.keepEditing")}
          </Button>
        </div>
      }
    >
      <Text>{t("discard.message")}</Text>
    </Dialog>
  );
}
